import EngineeringTheAscent from "./engineering-the-ascent";
import Feedback from "./feedback";
import HeroSection from "./hero-section";
import OurApps from "./our-apps";
import RealApps from "./real-apps";
import TrustedByMany from "./trusted-by-many";

export default function Home() {
  return (
    <>
      <HeroSection />
      <EngineeringTheAscent />
      <RealApps />
      <TrustedByMany />
      <OurApps />
      <Feedback />
    </>
  );
}
